<template>
    <div class="container-00">
      <div class="osc-block-00 osc-border-00 card-00" :style="mounterstyle">
      </div>
  </div>
</template>

<script>
 export default {
   /* spacerwidth: min 20px*/
   name: 'RackSpacerKit',
   props: ['spacerheight', 'spacerwidth'],
   methods: {},
   created: function() {
   },
   computed: {
     mounterstyle: {
       get: function() {
         const styles = []
         if (this.spacerheight != 'undefined') {
           styles.push(`height:${this.spacerheight}px`)
         }
         if (this.spacerwidth != 'undefined') {
           styles.push(`width:${this.spacerwidth}px`)
         }
         return styles.join(';')
       }
     },
   },
   data: () => ({
   }),
 }
</script>
